import { gql } from '@apollo/client';

export const SUBJECT_PASS_RATE = gql`
  query subjectPassRate($input: FilterArgs) {
    subjectPassRate(input: $input) {
      id
      name
      firstPassRate
      secondPassRate
      thirdPassRate
      fourthPassRate
    }
  }
`;
